const getTaxYears = (item) => {
    console.log(item, "__item");
    let taxYears = [];
    if (item?.rentalPropertyTaskId?.length) {
        item?.rentalPropertyTaskId?.forEach((rental) => {
            const date = new Date(rental?.rentalPropertyId?.taxYear);
            const year = date.getFullYear();
            taxYears.push(year);
        });
    }
    if (item?.truckDriverTaskId?.length) {
        item?.truckDriverTaskId?.forEach((truck) => {
            const date = new Date(truck?.truckDriverBasicInfoId?.taxYear);
            const year = date.getFullYear();
            taxYears.push(year);
        });
    }
    if (item?.personalCollectionTaskId?.length) {
        item?.personalCollectionTaskId?.forEach((personal) => {
            const date = new Date(personal?.prepSheetId?.taxYear);
            const year = date.getFullYear();
            taxYears.push(year);
        });
    }
    if (item?.generalBusinessTaskId?.length) {
        item?.generalBusinessTaskId?.forEach((business) => {
            const date = new Date(business?.businessInfoId?.taxYear);
            const year = date.getFullYear();
            taxYears.push(year);
        });
    }
    if (item?.workSheet1099TaskId?.length) {
        item?.workSheet1099TaskId?.forEach((workSheet) => {
            const date = new Date(workSheet?.taxYear);
            const year = date.getFullYear();
            taxYears.push(year);
        });
    }
    return taxYears;
};

export { getTaxYears };